<template>
  <div id="app" class="bg-1">
    <LoadPopup :progress="progress" :loadFlag="loadFlag" />
    <Music ref="musicCom" />
    <Tab ref="tabEl" :slideGroup="slideGroup" />
    <Popup ref="ruleEl">
      <img src="./assets/images/rule.png" class="rule-img">
    </Popup>
    <Popup ref="infoEl" :rbtn="rbtn">
      <Info />
    </Popup>
    <Popup ref="msgEl" rbtn="false">
      <div class="msg-box flex flex-around flex-column">
        <p class="msg-text">很遗憾，未中奖</p>
        <button class="btn btn-2" @click="shareShow" v-if="drawInfo.draw_status === 103">再次抽奖</button>
        <button class="btn btn-2" @click="goProduce" v-else>返回查看详情</button>
      </div>
    </Popup>
    <Share ref="shareEl" />
  </div>
</template>

<script>
import LoadPopup from './components/public/LoadPopup'
import Music from './components/public/Music'
import Share from './components/public/Share'

export default {
  name: 'app',
  data () {
    return {
      rbtn: 'false',
      progress: 0,
      loadFlag: false,
      slideGroup: ['One', 'Poster', 'Produce', 'Lottery']
    }
  },
  computed: {
    drawInfo () {
      return this.$store.state.drawInfo
    }
  },
  provide () {
    return {
      ruleHandle: flag => { flag ? this.$refs.ruleEl.showFn() : this.$refs.ruleEl.hideFn() },
      infoHandle: (flag, text = '') => {
        this.rbtn = text
        flag ? this.$refs.infoEl.showFn() : this.$refs.infoEl.hideFn()
      },
      msgHandle: flag => { flag ? this.$refs.msgEl.showFn() : this.$refs.msgEl.hideFn() },
      shareHandle: flag => { flag ? this.$refs.shareEl.showFn() : this.$refs.shareEl.hideFn() },
      slideHandle: n => { this.$refs.tabEl.slideToFn(n) }
    }
  },
  components: {
    LoadPopup,
    Music,
    Share,
    Info: () => import('./components/main/Info')
  },
  methods: {
    shareShow () {
      this.$refs.shareEl.showFn()
    },
    goProduce () {
      this.$refs.msgEl.hideFn()
      this.$refs.tabEl.slideToFn(2)
    },
    oauthFn () {
      this.$http.oauth().then(res => {
        if (res.status === 1) {
          window.location.href = res.result
        } else if (res.status === 9) {
          this.$store.setState('userInfo', res.result.userInfo)
          this.$store.setState('drawInfo', res.result.drawInfo)
          this.$nextTick(() => {
            this.imgLoaderFn()
          })
        }
      })
    },
    imgLoaderFn () {
      this.$imgLoader([
        require('./assets/images/logo.png'),
        require('./assets/images/bg1.png'),
        require('./assets/images/1.png'),
        require('./assets/images/2.png'),
        require('./assets/images/3.png'),
        require('./assets/images/4.png'),
        require('./assets/images/5.png'),
        require('./assets/images/6.png'),
        require('./assets/images/7.png'),
        require('./assets/images/8.png'),
        require('./assets/images/9.png'),
        require('./assets/images/10.png'),
        require('./assets/images/11.png'),
        require('./assets/images/12.png'),
        require('./assets/images/13.png'),
        require('./assets/images/14.png'),
        require('./assets/images/15.png'),
        require('./assets/images/16.png'),
        require('./assets/images/17.png'),
        require('./assets/images/18.png'),
        require('./assets/images/19.png'),
        require('./assets/images/20.png'),
        require('./assets/images/21.png'),
        require('./assets/images/22.png'),
        require('./assets/images/23.png'),
        require('./assets/images/24.png'),
        require('./assets/images/25.png'),
        require('./assets/images/26.png'),
        require('./assets/images/27.png'),
        require('./assets/images/28.png'),
        require('./assets/images/29.png'),
        require('./assets/images/30.png'),
        require('./assets/images/31.png'),
        require('./assets/images/32.png'),
        require('./assets/images/33.png'),
        require('./assets/images/34.png'),
        require('./assets/images/35.png'),
        require('./assets/images/36.png'),
        require('./assets/images/37.png'),
        require('./assets/images/38.png'),
        require('./assets/images/39.png')
      ], progress => {
        this.progress = progress
        if (progress === 1) {
          this.$refs.musicCom.playFn()
          document.addEventListener('WeixinJSBridgeReady', () => {
            this.$refs.musicCom.playFn()
          })
          setTimeout(() => {
            this.$refs.tabEl.slideToFn(0)
            this.loadFlag = true
          }, 1000)
        }
      })
    }
  },
  mounted () {
    this.$myWx.dufaultParam.successCallback = () => {
      this.$http.getShare().then(res => {
        this.$refs.shareEl.hideFn()
        if (res.status === 1) {
          this.$refs.msgEl.hideFn()
          this.$store.setState('drawInfo', res.result.drawInfo)
          this.$alert.msg(res.msg)
        }
      })
    }
    this.$myWx.wxInitFn()
    this.oauthFn()
  }
}
</script>

<style>
#app {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.rule-img {
  display: block;
  width: 4.83rem;
  margin: .8rem auto 0;
}
.msg-box {
  position: relative;
  height: 5.4rem;
  padding: .5rem .3rem;
}
.msg-box .msg-text {
  font-size: .56rem;
  font-weight: bold;
  color: #fff;
}
.msg-box .btn-2 {
  font-size: .34rem;
}
</style>
